import React, { useEffect, useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import moment from "moment";
import { getProgressColor } from "../../../company-dashboard-utils";
import ownerImage from "../../../../../assets/icons/userProfileIcone.png";
import CompanyDashboardAddKeyResultsPopup from "../../company-dashboard-add-popup/company-dashboard-add-key-results-popup/company-dashboard-add-key-results-popup";
import addREC from "../../../../../assets/icons/addREC.svg";
import { Drawer, IconButton, Tooltip } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import AvatarGroup from "@mui/material/AvatarGroup";
import "./company-dashboard-all-objective-drawer-side-bar.scss";
import CompanyDashboardEditObjectivePopup from "../../company-dashbaord-edit-popup/company-dashboard-edit-object-popup";
import { editKeyresult, updateObjective } from "../../../../../api/objectives";
import CompanyDashboardEditObjectiveDescriptionPopup from "../../company-dashbaord-edit-popup/company-dashboard-edit-object-description-popup/company-dashboard-edit-object-description-popup";
import CompanyDashboardEditKeyResultsPopup from "../../company-dashbaord-edit-popup/company-dashboard-edit-key-results-popup/company-dashboard-edit-key-results-popup";
import { usePermissions } from "../../../../../common/hooks/usePermissions";
import MODULES from "../../../../../constants/modules";
import { OverlayScrollbarsComponent } from "overlayscrollbars-react";
import CompanyDashboardAddKeyResultsOwnerPopup from "./company-dashboard-objective-drawer-side-bar-key-results-owner-popup";
import UserDashboardAllObjectiveDrawer from "../../../../user-dashboard/user-dashboard-all-objective-drawer/user-dashboard-all-objective-drawer";
import editIcons from "../../../../../assets/icons/editIcons.svg";
import dayjs from "dayjs";
import clearIcon from "../../../../../assets/icons/clearIcon.svg";

const CompanyDashboardAllObjectiveDrawerSideBar: any = (props: any) => {
  const {
    objectivesData,
    setInitiativeData,
    listOfKeyResultsData,
    setListOfKeyResultsData,
    employeesList,
    statusListObjectives,
    statusListKeyResults,
    saveKeyresult,
    selectedKeyResult,
    setSelectedKeyResult,
    setObjectivesData,
    fetchObjectivesById,
    setAlertMessage,
    setAlertType,
    setAlertOpen,
    setLoading,
  } = props;

  const [isOpenAddKeyResultsPopup, setIsOpenAddKeyResultsPopup] =
    useState(false);
  const [isOpenEditObjectivePopup, setIsOpenEditObjectivePopup] =
    useState(false);
  const [selectedObjectiveData, setSelectedObjectiveData] = useState<any>(null);
  const [
    isOpenEditObjectiveDescriptionPopup,
    setIsOpenEditObjectiveDescriptionPopup,
  ] = useState(false);
  const [isOpenAddKeyResultsOwnerPopup, setIsOpenAddKeyResultsOwnerPopup] =
    useState(false);
  const [anchorElOwner, setAnchorElOwner] = React.useState<null | HTMLElement>(
    null,
  );
  const [selectedMenuData, setSelectedMenuData] = useState([]);
  const [isShowUserObjectiveDrawer, setIsShowUserObjectiveDrawer] =
    useState(false);
  const [selectedApprover, setSelectedApprover] = useState<any>(null);

  const { canEdit: canEditObjectives } = usePermissions(MODULES.OBJECTIVES);
  const {
    canRead: canReadKeyResults,
    canWrite: canWriteKeyResults,
    canEdit: canEditKeyResults,
  } = usePermissions(MODULES.KEY_RESULTS);

  const [
    isOpenEditObjectiveKeyResultPopup,
    setIsOpenEditObjectiveKeyResultPopup,
  ] = useState(false);

  const handleOpenEditObjectiveKeyResultPopup = () => {
    setIsOpenEditObjectiveKeyResultPopup(true);
  };
  const handleOpenOwnerMenu = (
    event: React.MouseEvent<HTMLElement>,
    menuData: any,
  ) => {
    setSelectedMenuData(menuData?.owners || []);
    setAnchorElOwner(event.currentTarget);
  };

  const handleCloseOwnerMenu = () => {
    setAnchorElOwner(null);
    setSelectedMenuData([]);
  };

  const handleCloseEditObjectiveKeyResultPopup = () => {
    setIsOpenEditObjectiveKeyResultPopup(false);
  };
  useEffect(() => {
    if (!objectivesData?.keyResults || objectivesData.keyResults.length === 0)
      return;

    let updatedKeyResults = objectivesData.keyResults.map((item: any) => ({
      ...item,
      isSelected: false,
    }));

    if (selectedKeyResult?.pk) {
      updatedKeyResults = updatedKeyResults.map((item: any) =>
        item.pk === selectedKeyResult.pk ? { ...item, isSelected: true } : item,
      );
    } else {
      updatedKeyResults = updatedKeyResults.map((item: any) => ({
        ...item,
        isSelected: false,
      }));
    }
    setListOfKeyResultsData(updatedKeyResults);
  }, [objectivesData, selectedKeyResult]);
  const handleUnselectKeyResult = () => {
    const updatedList = listOfKeyResultsData.map((item: any) => ({
      ...item,
      isSelected: false,
    }));
    setListOfKeyResultsData(updatedList);
    setSelectedKeyResult(null); // remove selection
  };

  const handleOpenAddKeyResultsPopup = () => {
    setIsOpenAddKeyResultsPopup(true);
  };

  const handleCloseAddKeyResultsPopup = () => {
    setIsOpenAddKeyResultsPopup(false);
  };

  const handleOpenEditObjectivePopup = () => {
    setSelectedObjectiveData(objectivesData);
    setIsOpenEditObjectivePopup(true);
  };

  const handleCloseEditObjectivePopup = () => {
    setIsOpenEditObjectivePopup(false);
  };

  const handleSelect = (data: any) => {
    const updatedList = listOfKeyResultsData?.map((item: any) =>
      item.pk === data.pk
        ? { ...item, isSelected: true }
        : { ...item, isSelected: false },
    );
    setListOfKeyResultsData(updatedList);
    setInitiativeData(data);
    setSelectedKeyResult(data);
  };

  const handleOpenEditObjectiveDescriptionPopup = () => {
    setSelectedObjectiveData(objectivesData); // keep selected objective
    setIsOpenEditObjectiveDescriptionPopup(true);
  };

  const handleCloseEditObjectiveDescriptionPopup = () => {
    setIsOpenEditObjectiveDescriptionPopup(false);
  };
  const handleCloseAddKeyResultsOwnerPopup = () => {
    setIsOpenAddKeyResultsOwnerPopup(false);
  };

  const handleOpenKeyResultOwnerPopup = (keyResult: any) => {
    setSelectedKeyResult(keyResult);
    setIsOpenAddKeyResultsOwnerPopup(true);
  };

  const handleUpdateObjectiveDescription = async (descObj: any) => {
    setLoading(true);
    try {
      const payload = {
        objectiveDescription: descObj.description,
      };

      await updateObjective(objectivesData.pk, payload);
      setObjectivesData((prev: any) => ({
        ...prev,
        objectiveDescription: descObj.description,
      }));

      setTimeout(() => setLoading(false), 0);
      handleCloseEditObjectiveDescriptionPopup();
    } catch {
      setLoading(false);
    }
  };

  const handleUpdateObjective = async (updatedObj: any) => {
    setLoading(true);
    try {
      const payload = {
        objectiveName: updatedObj.objectiveName,
        objectiveDescription: updatedObj.objectiveDescription,
        startDate: dayjs(updatedObj.startDate || dayjs()).format("YYYY-MM-DD"),
        endDate: dayjs(updatedObj.endDate || dayjs()).format("YYYY-MM-DD"),
        status: updatedObj.status,
        createdAt: dayjs(updatedObj.createdAt || dayjs()).format("YYYY-MM-DD"),
        year: updatedObj.year,
        ownerIds: updatedObj.ownerIds,
        empty: false,
      };

      await updateObjective(updatedObj.id, payload);
      setObjectivesData((prev: any) => ({
        ...prev,
        ...updatedObj,
        owners: updatedObj.currentOwner
          ? [
              {
                employeeId: updatedObj.currentOwner,
                employeeName: updatedObj.ownerName,
              },
            ]
          : prev.owners,
      }));

      setAlertMessage("Description added successfully");
      setAlertType("success");
      setAlertOpen(true);
      fetchObjectivesById();
      setTimeout(() => setLoading(false), 0);
    } catch (error: any) {
      setAlertMessage(
        error?.response?.data?.message || "Failed to update description",
      );
      setAlertType("error");
      setAlertOpen(true);
      setLoading(false);
    }
  };

  const stringAvatar = (name: string, color?: string, styles?: any) => {
    if (!name) return { children: "?" };
    const parts = name.split(" ");
    const initials =
      parts.length === 1 ? parts[0][0] : `${parts[0][0]}${parts[1][0]}`;

    return {
      sx: {
        ...styles,
        bgcolor: color || "#403c6f",
      },
      children: initials.toUpperCase(),
    };
  };

  const handleUpdateKeyResult = async (krObj: any) => {
    setLoading(true);
    try {
      const payload = {
        ownerIds: krObj.ownerIds,
        title: krObj.title,
        description: krObj.description,
        weightage: krObj.weightage,
        startDate: dayjs(krObj.startDate || dayjs()).format("YYYY-MM-DD"),
        endDate: dayjs(krObj.endDate || dayjs()).format("YYYY-MM-DD"),
        comments: krObj.comments,
        objectives: krObj?.objectives || [],
      };

      await editKeyresult(krObj.pk, payload);
      fetchObjectivesById();
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
  return (
    <OverlayScrollbarsComponent
      className="company-dashboard-all-objective-drawer-side-bar-content"
      options={{
        scrollbars: {
          theme: "os-theme-dark",
          autoHide: "scroll",
          autoHideDelay: 400,
        },
      }}
    >
      <div className="company-dashboard-all-objective-drawer-side-bar-content-header">
        Name
        {canEditObjectives && (
          <button
            className="company-dashboard-edit-icon"
            onClick={handleOpenEditObjectivePopup}
          >
            <img src={editIcons} alt="edit" />
          </button>
        )}
      </div>

      <div
        className="company-dashboard-all-objective-drawer-side-bar-content-details"
        style={{
          borderBottom: `3px solid ${getProgressColor(objectivesData?.status).mainColor}`,
        }}
      >
        <div className="company-dashboard-all-objective-drawer-side-bar-content-details-content">
          <div>
            <div className="company-dashboard-all-objective-drawer-side-bar-content-details-content-main-label">
              {objectivesData?.objectiveName || ""}
            </div>
            <div className="company-dashboard-all-objective-drawer-side-bar-content-details-content-sub-label">
              Last Updated:
              {moment(objectivesData?.updatedAt || new Date()).format(
                "MM-DD-YYYY",
              )}
            </div>
          </div>
          <div className="company-dashboard-all-objective-drawer-side-bar-content-details-content-graph">
            <Box sx={{ position: "relative", display: "inline-flex" }}>
              <CircularProgress
                variant="determinate"
                value={100}
                size={72}
                thickness={6.2}
                sx={{
                  color: getProgressColor(objectivesData?.status).lightColor,
                }}
              />
              <CircularProgress
                variant="determinate"
                value={objectivesData?.progress || 0}
                size={72}
                sx={{
                  color: getProgressColor(objectivesData?.status).mainColor, // use string
                  position: "absolute",
                  left: 0,
                  "& .MuiCircularProgress-circle": {
                    strokeLinecap: "round",
                  },
                }}
                thickness={6.2}
              />
              <Box
                sx={{
                  top: 0,
                  left: 0,
                  bottom: 0,
                  right: 0,
                  position: "absolute",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Typography
                  variant="caption"
                  component="div"
                  sx={{ color: "#403C6F" }}
                >{`${Math.round(objectivesData?.progress || 0)}%`}</Typography>
              </Box>
            </Box>
          </div>
        </div>
      </div>
      <div className="company-dashboard-all-objective-drawer-side-bar-content-header">
        Description
        {canEditObjectives && (
          <button
            className="company-dashboard-edit-icon"
            onClick={handleOpenEditObjectiveDescriptionPopup}
          >
            <img src={editIcons} alt="edit" />
          </button>
        )}
      </div>
      <div className="company-dashboard-all-objective-drawer-side-bar-content-description">
        <OverlayScrollbarsComponent
          options={{
            scrollbars: {
              theme: "os-theme-dark",
              autoHide: "scroll",
              autoHideDelay: 400,
            },
          }}
          style={{
            maxHeight: "150px", // fixed height
            overflowY: "auto", // vertical scroll
            overflowX: "hidden", // prevent horizontal scroll
            whiteSpace: "normal", // wrap text
            wordWrap: "break-word",
            wordBreak: "break-word",
            paddingRight: "10px", // space for scrollbar
          }}
          className="company-dashboard-all-objective-drawer-side-bar-content-description-content"
        >
          {objectivesData?.objectiveDescription ||
            "No description has been added yet."}
        </OverlayScrollbarsComponent>
      </div>
      {canReadKeyResults && (
        <div className="company-dashboard-all-objective-drawer-side-bar-content-header">
          <div>
            Key Results
            <IconButton
              sx={{
                border: "1px solid  #CFCEDA",
                width: 24,
                height: 24,
                borderRadius: "50%",
                fontSize: "16px",
                color: "#403C6F",
                marginLeft: "8px",
                cursor: "default",
              }}
            >
              {objectivesData?.keyResults?.length || 0}
            </IconButton>
          </div>
          {canWriteKeyResults && (
            <div className="company-dashboard-all-objective-drawer-side-bar-content-header-actions">
              <button
                style={{
                  border: "none",
                  background: "none",
                  padding: 0,
                }}
                onClick={handleOpenAddKeyResultsPopup}
              >
                <img
                  src={addREC}
                  alt="Add Key Result"
                  style={{ cursor: "pointer" }}
                />
              </button>
            </div>
          )}
        </div>
      )}

      {canReadKeyResults && (
        <div>
          {listOfKeyResultsData.some((kr: any) => kr.isSelected) && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",

                background: "#FFFFFF", // light red background
                border: "1px solid #E9E9E8",
                borderRadius: "8px",
                padding: "8px 12px",
                marginBottom: "12px",
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  color: "#f37e7cff",
                  fontWeight: 500,
                  fontFamily: "Manrope, sans-serif",
                }}
              >
                Clear selected Key Result
              </Typography>
              <Tooltip title="Clear selected Key Result" arrow>
                <button
                  style={{
                    border: "none",
                    background: "none",
                    padding: 0,
                  }}
                  onClick={handleUnselectKeyResult}
                >
                  <img
                    src={clearIcon}
                    alt="Clear selected Key Result"
                    style={{
                      cursor: "pointer",
                      width: 17,
                      height: 17,
                    }}
                  />
                </button>
              </Tooltip>
            </div>
          )}

          {listOfKeyResultsData?.length > 0 ? (
            listOfKeyResultsData?.map((keyResult: any, index: number) => {
              return (
                <button
                  key={index + 1}
                  className="company-dashboard-all-objective-drawer-side-bar-content-key-results"
                  style={
                    keyResult?.isSelected ? { border: "1px solid #6E6D92" } : {}
                  }
                  onClick={() => {
                    handleSelect(keyResult);
                  }}
                >
                  <div className="company-dashboard-all-objective-drawer-side-bar-content-key-results-content">
                    <div
                      style={{
                        width: "calc(100% - 72px)",
                      }}
                      className="company-dashboard-all-objective-drawer-side-bar-content-key-results-content-main-label"
                    >
                      {keyResult?.title ||
                        "Achieve a client retention rate of at least 95% (membership-based)"}
                    </div>
                    <div className="company-dashboard-all-objective-drawer-side-bar-content-key-results-content-graph">
                      <Box
                        sx={{ position: "relative", display: "inline-flex" }}
                      >
                        <CircularProgress
                          variant="determinate"
                          value={100}
                          size={72}
                          thickness={6.2}
                          sx={{
                            color: getProgressColor(keyResult?.status)
                              .lightColor,
                          }}
                        />
                        <CircularProgress
                          variant="determinate"
                          value={keyResult?.progress || 0}
                          size={72}
                          sx={{
                            color: getProgressColor(keyResult?.status)
                              .mainColor,

                            position: "absolute",
                            left: 0,
                            "& .MuiCircularProgress-circle": {
                              strokeLinecap: "round",
                            },
                          }}
                          thickness={6.2}
                        />
                        <Box
                          sx={{
                            top: 0,
                            left: 0,
                            bottom: 0,
                            right: 0,
                            position: "absolute",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Typography
                            variant="caption"
                            component="div"
                            sx={{ color: "#403C6F" }}
                          >{`${Math.round(keyResult?.progress || 0)}%`}</Typography>
                        </Box>
                      </Box>
                    </div>
                  </div>
                  <div className="company-dashboard-all-objective-drawer-side-bar-content-key-results-content">
                    {keyResult?.owners?.length > 0 ? (
                      <div className="company-dashboard-all-objective-drawer-side-bar-content-key-results-content-owner">
                        <div className="company-dashboard-all-objective-drawer-side-bar-content-key-results-content-owner-label">
                          Owner
                        </div>
                        <div className="company-dashboard-all-objective-drawer-side-bar-content-key-results-content-owner-img">
                          <AvatarGroup
                            max={3}
                            spacing={7}
                            renderSurplus={() => (
                              <Avatar
                                sx={{ fontSize: 14 }}
                                style={{ cursor: "pointer !important" }}
                              >
                                +
                              </Avatar>
                            )}
                          >
                            {[keyResult.owners?.[0]]?.map(
                              (ownerDataInfo: any, index: number) => (
                                <Tooltip
                                  title={ownerDataInfo?.employeeName || ""}
                                  key={index + 1}
                                >
                                  <Avatar
                                    alt={ownerDataInfo?.employeeName}
                                    src={ownerDataInfo?.profileImage}
                                    {...(!ownerDataInfo?.profileImage &&
                                      stringAvatar(
                                        ownerDataInfo?.employeeName,
                                      ))}
                                    onClick={() => {
                                      // Open user details drawer for this owner
                                      setSelectedApprover({
                                        id: ownerDataInfo?.employeeId,
                                        name: ownerDataInfo?.employeeName,
                                      });
                                      setIsShowUserObjectiveDrawer(true);
                                    }}
                                    style={{ cursor: "pointer" }}
                                  />
                                </Tooltip>
                              ),
                            )}
                            {keyResult.owners?.length > 1 && (
                              <Avatar
                                {...stringAvatar(
                                  `${keyResult?.owners?.length - 1}`,
                                  "#CFCEDA",
                                )}
                                onClick={(event) =>
                                  handleOpenOwnerMenu(event, keyResult)
                                }
                                style={{ cursor: "pointer" }}
                              />
                            )}
                            {canWriteKeyResults && (
                              <Avatar
                                {...stringAvatar(`+`, "#CFCEDA")}
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  handleOpenKeyResultOwnerPopup(keyResult);
                                }}
                              />
                            )}
                          </AvatarGroup>
                          {selectedMenuData?.length > 1 ? (
                            <Menu
                              id="menu-appbar"
                              anchorEl={anchorElOwner}
                              keepMounted
                              open={Boolean(anchorElOwner)}
                              onClose={handleCloseOwnerMenu}
                            >
                              {selectedMenuData?.map(
                                (ownerDataInfo: any, index: number) => (
                                  <MenuItem
                                    key={`index-${index}-${ownerDataInfo?.pk}`}
                                    onClick={handleCloseOwnerMenu}
                                  >
                                    <Tooltip
                                      title={ownerDataInfo?.employeeName || ""}
                                      key={`index-${index}-${ownerDataInfo?.employeeName}`}
                                    >
                                      <Avatar
                                        alt={ownerDataInfo?.employeeName}
                                        src={ownerDataInfo?.profileImage}
                                        {...(!ownerDataInfo?.profileImage &&
                                          stringAvatar(
                                            ownerDataInfo?.employeeName,
                                          ))}
                                        onClick={() => {
                                          setSelectedApprover({
                                            id: ownerDataInfo?.employeeId,
                                            name: ownerDataInfo?.employeeName,
                                          });
                                          setIsShowUserObjectiveDrawer(true);
                                        }}
                                        style={{ cursor: "pointer" }}
                                      />
                                    </Tooltip>
                                  </MenuItem>
                                ),
                              )}
                              {canWriteKeyResults && (
                                <MenuItem
                                  onClick={() => {
                                    handleCloseOwnerMenu();
                                    handleOpenKeyResultOwnerPopup(keyResult);
                                  }}
                                >
                                  <Avatar
                                    {...stringAvatar(`+`, "#CFCEDA")}
                                    style={{ cursor: "pointer" }}
                                  />
                                </MenuItem>
                              )}
                            </Menu>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    ) : (
                      <div className="company-dashboard-all-objective-drawer-side-bar-content-key-results-content-owner">
                        <div className="company-dashboard-all-objective-drawer-side-bar-content-key-results-content-owner-label">
                          Owner
                        </div>
                        <div className="company-dashboard-all-objective-drawer-side-bar-content-key-results-content-owner-img">
                          <img src={ownerImage} alt="Owner" />
                        </div>
                      </div>
                    )}
                    <div className="company-dashboard-all-objective-drawer-side-bar-content-key-results-content-owner">
                      <div className="company-dashboard-all-objective-drawer-side-bar-content-key-results-content-owner-label">
                        Weight
                      </div>
                      <div
                        className="company-dashboard-all-objective-drawer-side-bar-content-key-results-content-owner-label"
                        style={{ marginTop: "14px" }}
                      >
                        {keyResult?.weightage
                          ? Math.round(keyResult?.weightage * 100) / 100
                          : 0}
                        %{/* round up weightage in two decimal */}
                      </div>
                    </div>
                    <div className="company-dashboard-all-objective-drawer-side-bar-content-key-results-content-owner">
                      <div className="company-dashboard-all-objective-drawer-side-bar-content-key-results-content-owner-label">
                        Actions
                      </div>
                      <div
                        className="company-dashboard-all-objective-drawer-side-bar-content-key-results-content-owner-label"
                        style={{ marginTop: "14px" }}
                      >
                        {canEditKeyResults && (
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              setSelectedKeyResult(keyResult);
                              handleOpenEditObjectiveKeyResultPopup();
                            }}
                            style={{
                              marginRight: "8px",
                              cursor: "pointer",
                              border: "none",
                              background: "none",
                              padding: 0,
                            }}
                          >
                            <img src={editIcons} alt="Edit" />
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </button>
              );
            })
          ) : (
            <div className="company-dashboard-all-objective-add-drawer-side-bar-add-content-key-results">
              <div className="company-dashboard-all-objective-add-drawer-side-bar-add-content-key-results-content">
                <div className="company-dashboard-all-objective-add-drawer-side-bar-add-content-key-results-content-label">
                  You don't have any key results
                </div>
                {canWriteKeyResults && (
                  <div className="company-dashboard-all-objective-add-drawer-side-bar-add-content-key-results-content-button">
                    <button
                      onClick={handleOpenAddKeyResultsPopup}
                      disabled={!canWriteKeyResults}
                      style={{
                        cursor: canWriteKeyResults ? "pointer" : "not-allowed",
                      }}
                    >
                      Add Key Results
                    </button>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      )}
      <CompanyDashboardAddKeyResultsPopup
        isOpenAddPopup={isOpenAddKeyResultsPopup}
        onCancel={handleCloseAddKeyResultsPopup}
        employeesList={employeesList}
        listOfKeyresultsData={listOfKeyResultsData}
        setListOfKeyresultsData={setListOfKeyResultsData}
        statusListKeyResults={statusListKeyResults}
        statusListObjectives={statusListObjectives}
        onSave={saveKeyresult}
        setLoading={setLoading}
        objectivesData={objectivesData}
      />
      <CompanyDashboardEditObjectivePopup
        isOpenAddPopup={isOpenEditObjectivePopup}
        onCancel={handleCloseEditObjectivePopup}
        newObjectiveData={selectedObjectiveData}
        setNewObjectiveData={setSelectedObjectiveData}
        employeesList={employeesList}
        statusListObjectives={statusListObjectives}
        onSave={handleUpdateObjective}
      />
      <CompanyDashboardEditObjectiveDescriptionPopup
        isOpenAddPopup={isOpenEditObjectiveDescriptionPopup}
        onCancel={handleCloseEditObjectiveDescriptionPopup}
        descriptionData={selectedObjectiveData}
        setDescriptionData={setSelectedObjectiveData}
        onSave={handleUpdateObjectiveDescription}
      />
      {isOpenEditObjectiveKeyResultPopup ? (
        <CompanyDashboardEditKeyResultsPopup
          isOpenAddPopup={isOpenEditObjectiveKeyResultPopup}
          onCancel={handleCloseEditObjectiveKeyResultPopup}
          employeesList={employeesList}
          statusListKeyResults={statusListKeyResults}
          selectedKeyResult={selectedKeyResult}
          keyResultId={selectedKeyResult?.pk}
          onSave={handleUpdateKeyResult}
          setLoading={setLoading}
          statusListObjectives={statusListObjectives}
          objectivesData={objectivesData}
          setAlertType={setAlertType}
          setAlertOpen={setAlertOpen}
          setAlertMessage={setAlertMessage}
        />
      ) : (
        ""
      )}

      {isOpenAddKeyResultsOwnerPopup && (
        <CompanyDashboardAddKeyResultsOwnerPopup
          isOpenAddPopup={isOpenAddKeyResultsOwnerPopup}
          onCancel={handleCloseAddKeyResultsOwnerPopup}
          employeesList={employeesList}
          listKeyResultsData={listOfKeyResultsData}
          setListKeyResultsData={setListOfKeyResultsData}
          setAlertType={setAlertType}
          setAlertOpen={setAlertOpen}
          setLoading={setLoading}
          setAlertMessage={setAlertMessage}
          statusListKeyResults={statusListKeyResults}
          keyResultId={selectedKeyResult?.pk}
          objectiveId={objectivesData?.pk}
          fetchObjectivesById={fetchObjectivesById}
        />
      )}
      <Drawer
        anchor={"bottom"}
        open={isShowUserObjectiveDrawer}
        onClose={(event, reason) => {
          if (reason === "backdropClick") {
            return;
          }
          setIsShowUserObjectiveDrawer(false);
        }}
        slotProps={{
          paper: {
            sx: {
              borderTopLeftRadius: 12,
              borderTopRightRadius: 12,
              top: "auto", // reset default
              marginTop: "10px", // 👈 space from top - reduced from 40px to 10px
              minHeight: "91.9vh",
              maxHeight: "91.9vh",
            },
          },
        }}
      >
        <UserDashboardAllObjectiveDrawer
          onClose={() => setIsShowUserObjectiveDrawer(false)}
          approverId={selectedApprover?.id}
          setIsShowAllObjectiveDrawer={setIsShowUserObjectiveDrawer}
          // Pass whatever props you need for user-specific dashboard
        />
      </Drawer>
    </OverlayScrollbarsComponent>
  );
};

export default CompanyDashboardAllObjectiveDrawerSideBar;
